/* ICExtract APEX video — click-to-load embed (no autoplay with sound, lazy). */
(function () {
  'use strict';
  Array.prototype.forEach.call(document.querySelectorAll('[data-ic-video]'), function (frame) {
    var play = frame.querySelector('[data-ic-video-play]');
    var tpl = frame.querySelector('[data-ic-video-embed]');
    if (!play || !tpl) return;
    play.addEventListener('click', function () {
      var wrap = document.createElement('div');
      wrap.className = 'ic-commercial-video__media';
      wrap.appendChild(tpl.content.cloneNode(true));
      var poster = frame.querySelector('.ic-commercial-video__poster');
      if (poster) poster.remove();
      play.remove();
      frame.appendChild(wrap);
      var media = wrap.querySelector('video');
      if (media && typeof media.play === 'function') { try { media.play(); } catch (e) {} }
    });
  });
})();
